// extracted by mini-css-extract-plugin
module.exports = {"notificationContainer":"notification_notificationContainer__3TnLc","notification":"notification_notification__3RgRF"};